import { Item as _Item } from '@studio/design-system/toggle/group';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Titles } from './constants.js';
import type { ItemProps } from './types.js';
import { Arrangement } from '#~/video/index.js';

/** `<Item>` component. */
export const Item = ({ className, value, ...props }: ItemProps): ReactElement => (
  <_Item
    className={twMerge(
      'px-4 x-off:fill-secondary enabled:hover:x-off:bg-unset enabled:hover:x-off:fill-primary x-on:bg-unset x-on:fill-light',
      className
    )}
    value={value}
    {...props}
  >
    <svg aria-label={Titles[value]} className='h-16 w-[26px]' role='img' viewBox='0 0 26 16'>
      <title>{Titles[value]}</title>

      {value === Arrangement.Single && (
        <path d='M26 1v14c0 .6-.5 1-1.1 1H1.1C.5 16 0 15.6 0 15V1c0-.6.5-1 1.1-1h23.8c.6 0 1.1.4 1.1 1z' />
      )}

      {value === Arrangement.Multiple && (
        <path d='M26 1v4.9c0 .6-.4 1-1 1h-9.9c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1H25c.6 0 1 .4 1 1zM10.9 9.1H1c-.6 0-1 .4-1 1V15c0 .6.4 1 1 1h9.9c.6 0 1-.4 1-1v-4.9c0-.5-.4-1-1-1zm0-9.1H1C.4 0 0 .4 0 1v4.9c0 .6.4 1 1 1h9.9c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM25 9.1h-9.9c-.6 0-1 .4-1 1V15c0 .6.4 1 1 1H25c.6 0 1-.4 1-1v-4.9c0-.5-.4-1-1-1z' />
      )}
    </svg>
  </_Item>
);
